import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid } from "swiper/modules";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";

import "swiper/css";
import "swiper/css/grid";
import "./TestimonialSwiper.css";
import StarRating from "./../../common_components/start_rating/StarRating";
import { AllReviews } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { useDispatch, useSelector } from "react-redux";

const testimonials = [
  {
    name: "Jason Keys",
    text:
      "After using Spirulina regularly, I feel more energetic & active throughout the day. Great quality and genuine product.",
    profileImg:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Neha P.",
    text:
      "I love that this Spirulina is natural and easy to include in my daily routine. I've noticed better immunity and digestion.",
    profileImg:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Suresh R.",
    text:
      "After using Spirulina regularly, I feel more energetic & active throughout the day. Great quality and genuine product.",
    profileImg:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Anita S.",
    text:
      "Pure, effective, and trustworthy. Highly recommended for anyone looking to improve their overall wellness naturally.",
    profileImg:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Rohan K.",
    text:
      "Excellent product quality and fast delivery. Will definitely buy again.",
    profileImg:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Rohan K.",
    text:
      "Excellent product quality and fast delivery. Will definitely buy again.",
    profileImg:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Rohan K.",
    text:
      "Excellent product quality and fast delivery. Will definitely buy again.",
    profileImg:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Rohan K.",
    text:
      "Excellent product quality and fast delivery. Will definitely buy again.",
    profileImg:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];

export default function TestimonialSwiper() {
  const dispatch = useDispatch();

  const all_review = useSelector((state) => state?.common?.all_review);

  useEffect(() => {
    dispatch(AllReviews());
  }, [dispatch]);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [rating, setRating] = useState(0);

  return (
    <div className="container">
      <div className="testimonial-section">
        <h2 className="section-title">
          What Our <span>Clients Say</span>
        </h2>

        <Swiper
          modules={[Grid]}
          spaceBetween={30}
          slidesPerView={2}
          speed={400}
          grid={{
            rows: 2,
            fill: "row",
          }}
          onSwiper={(swiper) => setSwiperInstance(swiper)}
          breakpoints={{
            0: {
              slidesPerView: 1,
              grid: { rows: 1 },
            },
            768: {
              slidesPerView: 2,
              grid: { rows: 1 },
            },
            992: {
              slidesPerView: 2,
              grid: { rows: 2 },
            },
          }}
        >
          {all_review?.map((item, index) => (
            <SwiperSlide key={item.id || index}>
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="header-left">
                    <div className="profile-circle">
                      <img
                        src={`${IDS.IMG_URL}${item?.profilephoto}`}
                        className="profile-image"
                        alt="not load"
                      />
                    </div>
                    <h5>{item?.name}</h5>
                  </div>

                  <StarRating rating={Number(item?.no_of_rating)} />
                </div>

                <p>{item?.comment}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation */}
        {all_review?.length > 3 && (
          <div className="testimonial-navigation">
            <button
              className="custom-prev"
              onClick={() => swiperInstance?.slidePrev()}
            >
              <SlArrowLeft />
            </button>

            <button
              className="custom-next"
              onClick={() => swiperInstance?.slideNext()}
            >
              <SlArrowRight />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
